// src/app/hooks/brand/use-measured-funnel.ts
//
// One fetch of the measured funnel per brand, shared by the Brand Monitoring
// header band (which shows the three metrics as stats) and the funnel card
// below it. Both surfaces must show the same numbers, so they read one result
// rather than issuing two requests that could resolve differently.
import { useEffect, useState } from "react";
import { fetchMeasuredFunnel, type MeasuredFunnel } from "@/app/services/brand/measured-funnel-api";

export interface MeasuredFunnelState {
  data: MeasuredFunnel | null;
  loading: boolean;
  failed: boolean;
}

export function useMeasuredFunnel(brandName?: string): MeasuredFunnelState {
  const [state, setState] = useState<MeasuredFunnelState>({
    data: null, loading: true, failed: false,
  });

  useEffect(() => {
    const brand = (brandName || "").trim();
    if (!brand) { setState({ data: null, loading: false, failed: false }); return; }
    let alive = true;
    setState({ data: null, loading: true, failed: false });
    fetchMeasuredFunnel(brand)
      .then((res) => { if (alive) setState({ data: res, loading: false, failed: false }); })
      .catch(() => { if (alive) setState({ data: null, loading: false, failed: true }); });
    return () => { alive = false; };
  }, [brandName]);

  return state;
}
